export default __webpack_public_path__ + "static/media/WinterSale_CampingFurniture_900x525.e8eab38f.jpg";